<template>
  <Section class="congrats" type="yellow">
    <div class="congrats__image"></div>
    <Heading class="congrats__title">Congratulations! The basic migration should be completed now.</Heading>
    <Description class="congrats__desc">
      But wait, there is more! Keep on reading if you've been using non-official karma bots
on Discord. So you want your karma and you want it now!
    </Description>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'

  export default {
    components: {
      Section,
      Heading,
      Description
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/styles/utils.sass';


  .congrats { 
    @include image('finalbg-2.jpg');
    background-size: cover;
    background-position: center center;
  }

  .congrats__image {
    width: 200px;
    height: 200px;
    margin: -10px auto 30px;
    @include image('karmabot-like.png');
    background-size: cover;
  }

  .congrats__title {
    color: #325613;
  }

  .congrats__desc {
    color: #3b5f1c;
  }
</style>
